export const DIR = 'ltr';
export const CODE = 'en';
export const ALT_LANG = 'عربي';
export const ALT_CODE = 'ar';
export const TITLE = 'fosol';
export const COPYRIGHT = '© 2019 fosol';
export const ABOUT = 'About';
export const CONTACT = 'Contact';
export const SUPPORT = 'Support';
export const TERMS = 'Terms';
export const FEATURES = 'Features';
export const TAG_LINE = 'The best way to communicate between students and teachers';
export const ANDROID = 'Android';
export const IPHONE = 'iPhone';
export const WEB_APP = 'Web App';
export const KEYWORDS =
    'app, chat, education, chat education, WhatsApp education, educatioanl chat, educatioanl messaging, teachers, students, submissions, quizzes, homework, exams, online exams, materials, polls, tasks';
export const DESCRIPTION =
    'Fosol is a group chatting app designed for teachers and students. Fosol ensures the privacy of your phone number and email. It helps in coordinating tasks, submissions and exams. It also provide a document library for each group.';
export const ABOUT_TEXT = `soon...`;



// WEBPACK FOOTER //
// ./src/lang/en.js